<template>
  <div class="flex h-screen bg-background-light overflow-hidden font-sans">
    <Sidebar @logout="handleLogout" />
    <div class="flex-1 flex flex-col overflow-y-auto">
      <TopBar :title="pageTitle" />
      <main class="p-8 w-full max-w-[1200px] mx-auto">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/layout/AppSidebar.vue'
import TopBar from '@/components/layout/TopBar.vue'

export default {
  components: { Sidebar, TopBar },
  props: {
    pageTitle: { type: String, default: 'Dashboard' }
  },
  methods: {
    handleLogout() {
      // Centralized logout logic
      this.$router.push('/login');
    }
  }
}
</script>